import { render, staticRenderFns } from "./MultipleWhatsAppTemplates.vue?vue&type=template&id=a528ee86&scoped=true"
import script from "./MultipleWhatsAppTemplates.vue?vue&type=script&lang=js"
export * from "./MultipleWhatsAppTemplates.vue?vue&type=script&lang=js"
import style0 from "./MultipleWhatsAppTemplates.vue?vue&type=style&index=0&id=a528ee86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a528ee86",
  null
  
)

export default component.exports